import request from '../utils/request'

// 用量统计报表
export function meterUsageReport (data) {
  return request({
    method: 'get',
    url: 'meterUsageReport',
    params: data
  })
}

// 单表已保存周期记录
export function meterFrozenFlowUse (data) {
  return request({
    method: 'get',
    url: 'meterFrozenFlowUse',
    params: data
  })
}
